import React from 'react';
import {FormattedMessage} from 'react-intl';
import * as OsUtil from '../../../util/OsUtil';
import {trackEvent} from '../../../../../tracking/amplitude/TrackingV2';
import {SEARCH_SHORTCUT} from '../../../../navigation/header/global-search/GlobalSearchButton';

const ShortcutsModal = () => {
	const altKeyText = OsUtil.isMac() ? 'Option' : 'Alt';

	trackEvent('Shortcuts Modal', 'Opened');

	const shortcuts = [
		{
			name: 'shortcut_modal_new.across_platform',
			entities: [
				{
					name: 'shortcut_modal_new.open_global-search',
					keys: SEARCH_SHORTCUT,
					title: '(Slash)',
				},
				{
					name: 'shortcut_modal_new.clear_filters',
					keys: `${altKeyText}+Shift+X`,
				},
				{
					name: 'shortcut_modal.open-shortcuts',
					keys: `${altKeyText}+Shift+Q`,
				},
				{
					name: 'shortcut_modal_new.navigation-my_tasks',
					keys: `${altKeyText}+Shift+W`,
				},
				{
					name: 'shortcut_modal_new.navigation-all_projects',
					keys: `${altKeyText}+Shift+P`,
				},
				{
					name: 'shortcut_modal_new.navigation-timesheets',
					keys: `${altKeyText}+Shift+R`,
				},
				{
					name: 'shortcut_modal_new.navigation-all_timelines',
					keys: `${altKeyText}+Shift+T`,
				},
				{
					name: 'shortcut_modal_new.navigation-all_reports',
					keys: `${altKeyText}+Shift+Y`,
				},
				{
					name: 'shortcut_modal_new.create-project',
					keys: `${altKeyText}+CTRL+P`,
				},
				{
					name: 'shortcut_modal_new.create-task',
					keys: `${altKeyText}+CTRL+T`,
				},
				{
					name: 'shortcut_modal_new.create-expense',
					keys: `${altKeyText}+CTRL+E`,
				},
			],
		},
		{
			name: 'shortcut_modal_new.inside_project',
			entities: [
				{
					name: 'shortcut_modal_new.navigation-project_baseline',
					keys: `${altKeyText}+Shift+1`,
				},
				{
					name: 'shortcut_modal_new.navigation-project_scoping',
					keys: `${altKeyText}+Shift+2`,
				},
				{
					name: 'shortcut_modal_new.navigation-project_task_board',
					keys: `${altKeyText}+Shift+3`,
				},
				{
					name: 'shortcut_modal_new.navigation-project_sprints',
					keys: `${altKeyText}+Shift+4`,
				},
				{
					name: 'shortcut_modal_new.navigation-project_retainer_tracking',
					keys: `${altKeyText}+Shift+5`,
				},
				{
					name: 'shortcut_modal_new.navigation-project_timeline',
					keys: `${altKeyText}+Shift+6`,
				},
				{
					name: 'shortcut_modal_new.navigation-project_financials',
					keys: `${altKeyText}+Shift+7`,
				},
				{
					name: 'shortcut_modal_new.navigation-project_nova_insights',
					keys: `${altKeyText}+Shift+8`,
				},
				{
					name: 'shortcut_modal_new.navigation-project_client',
					keys: `${altKeyText}+Shift+9`,
				},
				{
					name: 'shortcut_modal_new.navigation-project_files',
					keys: `${altKeyText}+Shift+0`,
				},
				{
					name: 'shortcut_modal_new.navigation-project_settings',
					keys: `${altKeyText}+Shift++`,
				},
				{
					name: 'shortcut_modal_new.navigation-project_connected_project_list',
					keys: `${altKeyText}+Shift+´`,
				},
			],
		},
	];

	const ShortCutHeader = ({name}) => {
		return (
			<tr>
				<td className="shortcut-modal-sub-title">
					<FormattedMessage id={name} />
				</td>
				<td />
			</tr>
		);
	};

	const ShortCutEntries = ({entities}) =>
		entities.map(entity => (
			<tr>
				<td title={entity.title}>{entity.keys}</td>
				<td>
					<FormattedMessage id={entity.name} />
				</td>
			</tr>
		));

	return (
		<div className="shortcut-table">
			<table>
				<thead>
					<tr>
						<th>
							<FormattedMessage id="shortcut_modal.hotkey" />
						</th>
						<th>
							<FormattedMessage id="shortcut_modal.action" />
						</th>
					</tr>
				</thead>
				<tbody>
					{shortcuts.map(group => (
						<>
							<ShortCutHeader name={group.name} />
							<ShortCutEntries entities={group.entities} />
						</>
					))}
				</tbody>
			</table>
		</div>
	);
};

ShortcutsModal.propTypes = {};

export default ShortcutsModal;
